import { createSlice } from "@reduxjs/toolkit";
var sendToAppModal = createSlice({
  name: "sendToAppModal",
  initialState: {
    OOSModalIsOpen: false
  },
  reducers: {
    openOOSModal: function openOOSModal(state) {
      state.OOSModalIsOpen = true;
    },
    closeOOSModal: function closeOOSModal(state) {
      state.OOSModalIsOpen = false;
    }
  }
});
var _sendToAppModal$actio = sendToAppModal.actions,
    openOOSModal = _sendToAppModal$actio.openOOSModal,
    closeOOSModal = _sendToAppModal$actio.closeOOSModal;
export { openOOSModal, closeOOSModal };
export default sendToAppModal.reducer;